export default __webpack_public_path__ + "static/media/moduleParents-fixed.5e9230d4.mp4";